import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Container,
} from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import REOPEN_TICKET from "../../../../resources/images/reopen-ticket.jpg";
import { useSearchParams } from "react-router-dom";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/tech-net";
import { toast } from "react-toastify";

const ReopenMessage = () => {
  const [isApiError, setIsApiError] = useState(false);
  const [searchParams] = useSearchParams();

  const reopenTicket = () => {
    const ticketId = searchParams.get("id");

    const headers = {
      "Content-Type": "application/json",
      Authorization: `API_BY_SID`,
    };

    fetch(`${HOSTNAME}${REST_URLS.REOPEN_TICKET}/${ticketId}`, {
      method: "PUT",
      headers: headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.message) {
          toast.error(data.message);
          setIsApiError(true);
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        toast.error("Something went wrong while reopening the ticket.");
        setIsApiError(true);
      });
  };

  useEffect(() => {
    reopenTicket();
  }, []);

  if (isApiError) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(to right, #fff3e0, #ffffff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Container maxWidth="sm">
          <Card elevation={4} sx={{ borderRadius: 4 }}>
            <CardContent sx={{ textAlign: "center", py: 4, px: 4 }}>
              <ErrorOutlineIcon
                sx={{ fontSize: 60, color: "error.main", mb: 2 }}
              />
              <Typography variant="h5" gutterBottom>
                Failed to Reopen Ticket
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Something went wrong while trying to reopen your ticket. Please
                try again later.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={reopenTicket}
                sx={{ mt: 3 }}
              >
                Try Again
              </Button>
            </CardContent>
          </Card>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #fff3e0, #ffffff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={4} sx={{ borderRadius: 4 }}>
          <CardContent sx={{ textAlign: "center", py: 2, px: 4 }}>
            <ReplayIcon sx={{ fontSize: 60, color: "warning.main", mb: 2 }} />
            <Typography variant="h4" gutterBottom>
              Ticket Reopened
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We've reopened your ticket as per your request. Our support team
              will review it and get in touch with you shortly.
            </Typography>
            <Box
              component="img"
              src={REOPEN_TICKET}
              alt="Reopened Ticket"
              sx={{
                width: "100%",
                objectFit: "contain",
              }}
            />
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ReopenMessage;
